import { Expose } from 'class-transformer';
import { Model } from './model';
import { ApplicationType, Permissions, UserGender } from '../../common';

export class DecodedJWT extends Model {
  @Expose() sub: string;
  @Expose() name: string;
  @Expose() email: string;
  @Expose() permission: Permissions[] = [];
  @Expose() gender: UserGender;
  @Expose() hasCategories: boolean = false;
  @Expose() whiteLabelDashboardLogoURL: string = null;
  @Expose() appName: string;
  @Expose() appsType: ApplicationType[];
}
